module.exports = __webpack_public_path__ + "img/f.186762a3.jpg";